import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { SensorsBillingEstimates } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<UseQueryOptions<SensorsBillingEstimates, Error>, 'queryKey' | 'queryFn'>
}

export const useSensorsBillingEstimatesRequest = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useQuery<SensorsBillingEstimates, Error>(
    [Entities.SensorBillingEstimates],
    async () => {
      const { data } = await api.v1AdminSensorsBillingEstimatesGet()
      return data as SensorsBillingEstimates
    },
    options
  )
}
